#### Update webhook subscription conflicts

We’ve introduced a new result format for [`updateWebhookSubscriptionDeliveryConfiguration`].

Webhook subscriptions must be unique based on their `schemeId`, `eventTypeCode`, `hirerId` & `url`.
Attempting to create a duplicate webhook subscription with [`createWebhookSubscription`] would correctly return a [mutation conflict].
However, we didn’t properly handle updating a webhook subscription’s `url` to conflict with an existing subscription.

💥 If your software uses [`updateWebhookSubscriptionDeliveryConfiguration`],
update the selection set to account for this change:

```diff label="GraphQL"
mutation($input: UpdateWebhookSubscriptionDeliveryConfigurationInput!) {
  updateWebhookSubscriptionDeliveryConfiguration(input: $input) {
-     webhookSubscription {
-       url
-       maxEventsPerAttempt
-     }
+     __typename
+     ... on UpdateWebhookSubscriptionDeliveryConfigurationPayload_Success {
+       webhookSubscription {
+         url
+         maxEventsPerAttempt
+       }
+     }
+     ... on UpdateWebhookSubscriptionDeliveryConfigurationPayload_Conflict {
+       conflictingWebhookSubscription {
+         id {
+           value
+         }
+       }
    }
  }
}
```

Then, update your code to check for conflicts in one of two new ways:

```javascript
if (
   // Option 1: test for existence of conflict field
   response.data?.conflictingWebhookSubscription
   // Option 2: test name of the response type
   response.data?.__typename === 'CreateWebhookSubscriptionDeliveryConfigurationPayload_Conflict'
) {
  // Handle conflict here
}
```

[`createwebhooksubscription`]: /schema/mutation/createWebhookSubscription
[`updatewebhooksubscriptiondeliveryconfiguration`]: /schema/mutation/updateWebhookSubscriptionDeliveryConfiguration
[mutation conflict]: /graphql/seek-api-conventions#mutation-conflicts
